module.exports = {
  sanity: {
    projectId:
      process.env.GATSBY_SANITY_PROJECT_ID || "qht1v59y",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
};
